import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Elena', 'Carlos', 'María', 'José', 'Ana', 'Luis', 'Sofía', 'Miguel', 'Carmen', 'Jorge'];
const LOCATIONS = ['Ciudad de México', 'Guadalajara', 'Monterrey', 'Puebla', 'Querétaro', 'Mérida', 'Veracruz', 'León', 'Toluca', 'Cancún'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentLocation, setCurrentLocation] = useState('');
  const [timeAgo, setTimeAgo] = useState(0);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showNotification = () => {
    // Pick random data
    const name = NAMES[Math.floor(Math.random() * NAMES.length)];
    const location = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
    const time = Math.floor(Math.random() * 40) + 2; // 2-42 minutes
    setCurrentName(name);
    setCurrentLocation(location);
    setTimeAgo(time);
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next notification (random 8-15 seconds)
      const nextDelay = Math.floor(Math.random() * 7000) + 8000;
      setTimeout(showNotification, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-164">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -20
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-lg border border-gray-100 p-4 max-w-xs flex items-center gap-3" data-id="element-165">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-166">
            <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-167" />
          </div>
          <div data-id="element-168">
            <p className="text-sm font-semibold text-gray-800" data-id="element-169">
              {currentName} de {currentLocation}
            </p>
            <p className="text-xs text-gray-500" data-id="element-170">
              Compró hace {timeAgo} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}